import { createFileRoute } from "@tanstack/react-router";
import i18n from "i18next";
import { ConfiguratorLogSearchView } from "src/components/views/erp/configurator/logSearch/ConfiguratorLogSearchView.tsx";

export const Route = createFileRoute("/_authenticated/_shell/erp/configurator/logSearch")({
	staticData: { title: i18n.t("configurator_log"), legacyViewKey: "configuratorLogSearchPage" },
	component: RouteComponent,
});

function RouteComponent() {
	return <ConfiguratorLogSearchView />;
}
